import i18n from 'i18n';
import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import {
  FaAngleDown,
  FaAngleUp,
  FaTrash,
  FaExclamationCircle,
} from 'react-icons/fa';
import { cnpjFormat, cpfFormat, formatName } from 'utils/AuxiliarFunctions';
import {
  formatISO2DisplayDateString,
  formatISO2DisplayTimeString,
} from 'utils/dateFunctions';
import { PaginationComponent } from 'pages/SearchPage/components/Pagination';
import { useRemoveConsentModalContext } from 'pages/SharePage/Context/RemoveConsentModalContext';
import { useRenewConsentModalContext } from 'pages/SharePage/Context/RenewConsentModalContext';
import { useSharePageUtils } from 'pages/SharePage/utils/useSharePageUtils';

export function GrantedConsentsTab({ data, type, subject, searchFilter }) {
  const [isOpen, setIsOpen] = useState(false);
  const [itensPerPage, setItensPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const pages = Math.ceil((data[type]?.length || 0) / itensPerPage);
  const startIndex = currentPage * itensPerPage;
  const endIndex = startIndex + itensPerPage;
  const currentItems = filterToDisplayList(data?.[type]);
  const { setRemoveConsentModalState } = useRemoveConsentModalContext();
  const { setRenewConsentModalState } = useRenewConsentModalContext();

  const { checkIfPastDate } = useSharePageUtils();

  function filterToDisplayList(listToFilter) {
    if (listToFilter) {
      return listToFilter
        ?.slice(startIndex, endIndex)
        ?.filter(
          (filter) =>
            filter?.pat_name
              ?.toUpperCase()
              ?.includes(searchFilter.toUpperCase()) ||
            filter?.pat_id?.includes(searchFilter) ||
            filter?.date?.includes(searchFilter),
        );
    } else {
      return [];
    }
  }

  return (
    <div>
      <button
        className="dropdownTitleButton"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? (
          <FaAngleUp className="tabArea-angleIcon" />
        ) : (
          <FaAngleDown className="tabArea-angleIcon" />
        )}
        <p className="dropdownTitle">Concedidos</p>
        <strong className="radius">
          {searchFilter === ''
            ? data[type]?.length || 0
            : currentItems.length || 0}
        </strong>
      </button>
      {isOpen ? (
        <>
          <div className="consents-shareTable">
            <div className="consents-shareTableHeader">
              {type === 0 ? (
                <div className="first">
                  <p> CPF</p>
                </div>
              ) : (
                <div className="first">
                  <p> CNES/CNPJ </p>
                </div>
              )}
              <div className="nome">
                <p> Nome </p>
              </div>
              <div className="date">
                <p>Data</p>
              </div>
              <div className="time">
                <p>Hora</p>
              </div>
              <div className="vigency">
                <p>Validade</p>
              </div>
              <div className="action">
                <p>Ação</p>
              </div>
            </div>

            {data ? (
              <>
                {currentItems?.map((consent, index) => (
                  <>
                    <div
                      className="consents-shareTableBody"
                      key={`consentItem-${
                        consent.pat_id || 'Não Encontrado'
                      }-${index}`}
                    >
                      {type === 0 ? (
                        <div
                          className={
                            checkIfPastDate(consent.dateVigency)
                              ? 'textConsentExpired first'
                              : 'first'
                          }
                        >
                          <p>{cpfFormat(consent.pat_id || 'Não Encontrado')}</p>
                        </div>
                      ) : (
                        <div
                          className={
                            checkIfPastDate(consent.dateVigency)
                              ? 'textConsentExpired first'
                              : 'first'
                          }
                        >
                          <p>
                            {cnpjFormat(consent.pat_id || 'Não Encontrado')}
                          </p>
                        </div>
                      )}

                      {type === 0 ? (
                        <div
                          className={
                            checkIfPastDate(consent.dateVigency)
                              ? 'textConsentExpired nome'
                              : 'nome'
                          }
                        >
                          <p>
                            {formatName(consent.pat_name || 'Não Encontrado')}
                          </p>
                        </div>
                      ) : (
                        <div
                          className={
                            checkIfPastDate(consent.dateVigency)
                              ? 'textConsentExpired nome'
                              : 'nome'
                          }
                        >
                          <p>{consent.pat_name || 'Não Encontrado'}</p>
                        </div>
                      )}

                      <div
                        className={
                          checkIfPastDate(consent.dateVigency)
                            ? 'textConsentExpired date'
                            : 'date'
                        }
                      >
                        <p>
                          {formatISO2DisplayDateString(
                            consent.horario,
                            i18n.language || 'Não Encontrado',
                          )}
                        </p>
                      </div>
                      <div
                        className={
                          checkIfPastDate(consent.dateVigency)
                            ? 'textConsentExpired time'
                            : 'time'
                        }
                      >
                        <p>
                          {formatISO2DisplayTimeString(
                            consent.horario,
                            i18n.language || 'Não Encontrado',
                          ).slice(0, -3)}
                        </p>
                      </div>
                      <div
                        className={
                          checkIfPastDate(consent.dateVigency)
                            ? 'textConsentExpired vigency'
                            : 'vigency'
                        }
                      >
                        <p>
                          {consent.dateVigency === null ||
                          consent.dateVigency === undefined
                            ? 'Até revogação manual'
                            : formatISO2DisplayDateString(
                                consent.dateVigency,
                                i18n.language || 'Não Encontrado',
                              )}
                        </p>
                      </div>
                      <div className="action">
                        {checkIfPastDate(consent.dateVigency) ? (
                          <button
                            onClick={() =>
                              setRenewConsentModalState({
                                isOpen: true,
                                pat_name: consent.pat_name,
                              })
                            }
                            className="shareAlertButton"
                          >
                            <FaExclamationCircle className="exclamation" />
                          </button>
                        ) : (
                          <button
                            onClick={() =>
                              setRemoveConsentModalState({
                                isOpen: true,
                                subjectId: subject,
                                pat_id: consent.pat_id,
                                pat_name: consent.pat_name,
                                consentType: type,
                              })
                            }
                            className="deleteButton"
                          >
                            <FaTrash className="trash" />
                          </button>
                        )}
                      </div>
                    </div>
                  </>
                ))}
                <PaginationComponent
                  items={itensPerPage}
                  totalItens={data[type]?.length || 0}
                  setItensPerPage={setItensPerPage}
                  setCurrentPage={setCurrentPage}
                  pages={pages}
                  currentPage={currentPage}
                />
              </>
            ) : (
              <> </>
            )}
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
}
GrantedConsentsTab.propTypes = {
  data: PropTypes.element.isRequired,
  type: PropTypes.number.isRequired,
  subject: PropTypes.element.isRequired,
  searchFilter: PropTypes.element.isRequired,
};
